import { cn } from "@/lib/utils";

interface CustomerStoryStatValueProps {
  value: string;
  /** Crossfade to gradient/secondary on hover (stats band). */
  hoverGradient?: boolean;
  className?: string;
}

export function CustomerStoryStatValue({
  value,
  hoverGradient = false,
  className,
}: CustomerStoryStatValueProps) {
  if (!hoverGradient) {
    return <p className={cn("text-grey-950 w-fit", className)}>{value}</p>;
  }

  return (
    <span
      className={cn(
        "customer-story-stat-hover relative inline-block w-fit",
        className
      )}
    >
      <span className="text-grey-950">{value}</span>
      <span
        className="customer-story-stat-gradient pointer-events-none absolute inset-0 select-none"
        aria-hidden
      >
        {value}
      </span>
    </span>
  );
}
